import { Vue, Component, Inject, Model, Prop, Watch } from 'vue-property-decorator'
import { InputRow, ListColumn } from "../models";
import { normalizeModel, shuffle } from "../utils";
import App from '../App'

declare let Sortable: any;

interface ICommand {
  label: string;
  mode: 'normal' | 'selection' | 'item'
  execute(vm: FormInlineList, item?: any): void;
}

@Component({
  name: 'FormInlineList'
})
export default class FormInlineList extends Vue {
  @Prop() inputs: InputRow[];

  @Prop() columns: ListColumn[];

  @Prop() items: any[];

  extendBag: { [k: string]: any } = {}

  ticktock = 0

  show = false

  currentIndex: number | null =  null

  selected: number[] = []

  sorting: {
    key: string | null;
    ast: boolean;
  } | null = null

  private _sortable: any

  get selectionState() {
    let len = this.selected.length
    return len === 0 ? 'none' : (len === this.items.length ? 'all' : 'some')
  }

  commands: ICommand[] = []

  executeCommand(command: ICommand, item?: any) {
    command.execute(this, item)
  }

  reset() {
    this.ticktock = 0
    this.show = false
    this.currentIndex = null
    this.selected = []
    this.sorting = null
  }

  changeSelection() {
    let selected: number[] = []
    if (this.selected.length === 0) {
      for (let i = 0; i < this.items.length; i++)
        selected.push(i)
    }
    this.selected = selected
  }

  add() {
    this.currentIndex = this.items.push(normalizeModel({}, this.inputs)) - 1
  }

  async remove(event: MouseEvent, index:number) {
    let app = this.$root.$children[0] as App
    let el = event.srcElement!.parentElement!.parentElement!
    if (await app.exposeAndConfirm(el, '删除操作不可恢复, 是否继续?')) {
      let pos = this.selected.indexOf(index)
      if (pos !== -1) {
        this.selected.splice(pos, 1)
      }
      for (let i=0; i<this.selected.length; i++) {
        if (this.selected[i] > index)
          this.selected[i] -= 1
      }
      this.items.splice(index, 1)
    }
  }

  removeSelected() {
    if (!this.selected.length)
      return;
    let cc = this.selected.length
    for (let i=0; i<this.items.length; i++) {
      if (this.selected.indexOf(i)!==-1) {
        this.items.splice(i, 1)
        i--;
        if (!--cc)
          break
      }
    }
    this.selected = []
  }

  clone(index) {
    function copy(o) {
      let co = {}
      for (let k in o) {
        co[k] = o[k]
      }
      return co
    }
    let item = copy(this.items[index])
    let n = prompt('number')
    if (n) {
      let number = parseInt(n)
      for (let i=0; i<number; i++) {
        this.items.push(item)
      }
    }
  }

  enterSorting() {
    if (this.sorting)
      return
    if (this.selected.length) {
      this.selected = []
    }
    this.sorting = {
      key: null,
      ast: false,
    }
    let el = this.$el.querySelector('div.wg-list')!
    this._sortable = Sortable.create(this.$el.querySelector('div.wg-list div.body')!, {
      animation: 120,
      onUpdate: evt => {
        if (this.sorting) {
          this.ticktock += 1
          let s = this.sorting
          s.key = null
          this.items.splice(evt.newIndex, 0, this.items.splice(evt.oldIndex, 1)[0])
        }
      },
      onStart: evt => {
        el.classList.add('dragging')
      },
      onEnd: evt => {
        el.classList.remove('dragging')
      }
    })
  }

  leaveSotring() {
    if (this.sorting) {
      this.sorting = null
    }
    if (this._sortable) {
      this._sortable.destroy()
      this._sortable = undefined
    }
  }

  toggleSorting() {
    if (!this.sorting)
      this.enterSorting()
    else
      this.leaveSotring()
  }

  reverse() {
    if (this.sorting) {
      let ss = this.sorting
      if (ss.key) {
        this.sortBy(ss.key, !ss.ast)
      }
      else {
        this.items.reverse()
      }
    }
  }

  shuffle() {
    if (this.sorting) {
      shuffle(this.items).forEach((item, i) => {
        Vue.set(this.items, i, item)
      })
      this.sorting.key = null
    }
  }

  sortBy(key: string, ast: boolean) {
    if (!this.sorting)
      return
    let ss = this.sorting
    let tostr = val => val === undefined || val === null ? '' : val.toString()
    if (ss.key !== key || ss.ast !== ast) {
      ss.key = key
      ss.ast = ast
      let compare = new Intl.Collator('en', { numeric: true }).compare
      this.items.sort((a, b) => {
        let aValue = a[key]
        let bValue = b[key]
        let result: number
        if (typeof aValue === 'number' && typeof bValue === 'number')
          result = aValue - bValue
        else if (typeof aValue === 'boolean' && typeof bValue === 'boolean')
          result = (aValue ? 1 : 0) - (bValue ? 1 : 0)
        else
          result = compare(tostr(aValue), tostr(bValue))
        return ast ? result : -result;
      })
    }
  }
}
